import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden flex items-center justify-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4b51f74b3c9a2d7463d216c8f699b204.jpg"
          alt="Creators with magazines"
          className="w-full h-full object-cover object-center"
        />
        {/* Uniform overlay — no patchy left-to-right gradient */}
        <div className="absolute inset-0 bg-black/55" />
        {/* Subtle vignette for depth */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40" />
      </div>

      {/* Content — centered, offset down to clear the fixed navbar */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 flex flex-col items-center text-center pt-24 md:pt-28">
        {/* Logo */}
        <div className="mb-6">
          <img
            src="https://static.readdy.ai/image/4d6c3a16e55b19be7241991d4b9fbbd2/6a628f4368e3dfcd99987da58a77cedb.svg"
            alt="Make It A Magazine"
            className="w-full max-w-[280px] md:max-w-[380px] h-auto object-contain mx-auto"
          />
        </div>

        <p className="text-[#F0EAD6] text-xs tracking-[0.35em] uppercase font-semibold mb-6">
          Print. Presence. Permanence.
        </p>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-light text-white leading-[1.1] mb-7">
          In a Digital World,<br />
          <em className="italic">Make It Real.</em>
        </h1>

        <p className="text-white/80 text-base md:text-lg font-light leading-relaxed mb-10 max-w-2xl">
          Create something memorable. Give your audience access to your content, unplugged — something they can hold, keep, and return to. Your magazine could be in people&apos;s hands in a matter of weeks.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/apply"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#C41E3A] text-white text-sm font-semibold tracking-wide whitespace-nowrap hover:bg-[#A0182E] transition-colors cursor-pointer"
          >
            Make It A Magazine
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </Link>
          <Link
            to="/creators"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-white/50 text-white text-sm font-semibold tracking-wide whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
          >
            See How It Works
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <span className="w-5 h-5 flex items-center justify-center text-white/50">
          <i className="ri-arrow-down-line" />
        </span>
      </div>
    </section>
  );
}
